import { styled } from 'parkdepot-shared/theme'

export type IconProps = {
    $size?: 'small' | 'medium' | 'large'
    marginTop?: string
    color?: string
    fontWeight?: number
    $clickable?: boolean
}
const icontSizes = {
    small: '1.4rem',
    medium: '2rem',
    large: '2.4rem'
}

const Icon = styled<'i', IconProps>(
    'i',
    ({ $theme, $size = 'small', marginTop, color = $theme.colors.black, fontWeight = 400, $clickable }) => ({
        marginTop: marginTop || 0,
        fontSize: icontSizes[$size],
        color,
        fontWeight,
        cursor: $clickable ? 'pointer' : 'default'

        // [$theme.mediaQuery.large]: {
        //     height: '1.4rem',
        //     width: '1.4rem'
        // }
    })
)

export default Icon
